import React from "react";
import { TrackingCaseDocumentFieldValueEditModalTemplate } from "themes/application/tracking-case/components";
import { observer } from "mobx-react";
import { TrackingCaseDocumentFieldValueEditModalStore } from "application/tracking-case/stores";
import { setCurrentView } from "core/utils";

@setCurrentView((rootStore, componentProps) => new TrackingCaseDocumentFieldValueEditModalStore(rootStore, componentProps), "trackingCaseDocumentFieldValueEditModalStore")
@observer
class TrackingCaseDocumentFieldValueEditModal extends React.Component {
    render() {
        return <TrackingCaseDocumentFieldValueEditModalTemplate {...this.props} />;
    }
}

export default TrackingCaseDocumentFieldValueEditModal;